import React from "react";

const TrendSection = ({ insights }) => {
  return (
    <div className="panel-grid">
      <div className="dashboard-panel dashboard-panel-wide">
        <h2>Last 7 Days Visit Trend</h2>
        <div className="timeline-grid">
          {insights.trend7Days.map((day) => {
            const heightPct = Math.max(
              (day.count / insights.peak7Days) * 100,
              day.count > 0 ? 12 : 4,
            );
            return (
              <div className="timeline-col" key={day.key}>
                <span className="timeline-count">{day.count}</span>
                <div className="timeline-bar" style={{ height: `${heightPct}%` }} />
                <span className="timeline-day">{day.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrendSection;
